import src from "IMAGE";
export default { src, width: 1919, height: 1847, blurWidth: 0, blurHeight: 0};
